
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-select/dist/react-select.min.css';

import './_style.scss'
import '../../scss/forms.scss'

import React from 'react';

import { connect } from 'react-redux';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';

import { FiltroDinamico, GridDinamico } from '@newspacebpo/newspace-react-grid-filter-bfveic';
import * as BuscaActions from '../../store/ducks/protocolo/busca/actions';
import * as VisualizarActions from '../../store/ducks/protocolo/visualizar/actions';
import { redirectHandled } from '../../util/helper';
//import * as DynamicActions from '../../store/ducks/__dynamicFilters/actions';
class ConsultaProtocolo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disable_forms: true,
      redirect: false,
      url: 'protocolo/consulta/visualizar/',
      options: this.options,
    };
  }

  visualizarProtocolo = async (event, row) => {
    redirectHandled(this.props.history, `${this.state.url}/${row.IdProtocolo}`)   
  };

  render() {
    const { protocolos } = this.props;
    const tableActions = [
      {
        icon: "fa fa-eye acoes_mg_left",
        action: this.visualizarProtocolo,
        buttonColor: 'ghost-primary'
      }
    ]
    return (
      <Row>
        <Col sm={8} md={12} style={{ flexBasis: 'auto' }}>
          <Card>
            <CardHeader>
              <i className="icon-note" />
              <strong>Consulta Protocolo</strong>{' '}
            </CardHeader>
            <CardBody>
              <FiltroDinamico {...this.props}  name="consultar" service="protocolo"/>
              <Row className="mt-3 row_protocolo">
                <Col>
                <GridDinamico {...this.props} tableActions={tableActions} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(BuscaActions, dispatch),
  actionsVisualizar: bindActionCreators(VisualizarActions, dispatch),
});

export default connect(
  mapStateToProps, 
  mapDispatchToProps)
(ConsultaProtocolo);
